export const UPDATE_SKILLS = 'profileCard:updateSkills';
export const COMPANY_RELATIONSHIP_READY = 'profileCard:companyRelationReady';
